import {Record as record} from 'immutable';

import {resolve} from '../../helpers/LinkMapper';

const defaults = {
    requestorName: null,
};

class SmartcardAssociationConfirmation extends record(defaults) {
    static fromJSON(json = {}) {
        return new SmartcardAssociationConfirmation({
            requestorName: resolve(json.requestorName).with(String),
        });
    }
}

export default SmartcardAssociationConfirmation;
